import { BUSINESS } from "@/data/site";
import { PageHero } from "@/components/PageHero";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-display text-xl font-semibold text-brand-blue">{title}</h2>
    <div className="mt-3 space-y-3 text-slate-600 leading-relaxed">{children}</div>
  </div>
);

export function PrivacyPolicy() {
  return (
    <>
      <PageHero label="Legal" title="Privacy Policy" crumbs={[{ label: "Privacy Policy" }]} />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <p className="text-slate-600 leading-relaxed">
            {BUSINESS.name} ("we", "us") respects your privacy. This policy explains how we collect, use and protect the personal information you provide through our website.
          </p>
          <Section title="Information we collect">
            <p>When you submit an enquiry or quote request, we collect details such as your name, phone number, email address, postcode and any message you provide. We only collect information necessary to respond to your enquiry and provide our services.</p>
          </Section>
          <Section title="How we use your information">
            <p>We use your information to respond to enquiries, provide quotes, arrange services, and communicate with you about your project. We do not sell your personal information to third parties.</p>
          </Section>
          <Section title="Data security">
            <p>We take reasonable steps to protect your information from misuse, loss and unauthorised access. Information submitted through our website is transmitted securely.</p>
          </Section>
          <Section title="Contact us">
            <p>For any privacy questions, contact us at <a href={BUSINESS.emailHref} className="text-brand-electric hover:underline">{BUSINESS.email}</a> or {BUSINESS.phone}.</p>
          </Section>
        </div>
      </section>
    </>
  );
}

export function Terms() {
  return (
    <>
      <PageHero label="Legal" title="Terms & Conditions" crumbs={[{ label: "Terms & Conditions" }]} />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <p className="text-slate-600 leading-relaxed">
            These terms govern your use of the {BUSINESS.name} website. By using this website, you agree to these terms.
          </p>
          <Section title="Website content">
            <p>Information on this website is provided in good faith for general information purposes. Service details, product options and any incentive information are indicative and subject to assessment, eligibility and current program rules.</p>
          </Section>
          <Section title="Quotes and enquiries">
            <p>Submitting an enquiry does not create a binding agreement. All work is subject to a formal quote and acceptance. Pricing is confirmed following a site assessment.</p>
          </Section>
          <Section title="Incentives and rebates">
            <p>Any reference to government incentives such as the Victorian Energy Upgrades program is general in nature. Eligibility and amounts are not guaranteed and depend on current program rules and property eligibility.</p>
          </Section>
          <Section title="Contact us">
            <p>Questions about these terms? Contact us at <a href={BUSINESS.emailHref} className="text-brand-electric hover:underline">{BUSINESS.email}</a> or {BUSINESS.phone}.</p>
          </Section>
        </div>
      </section>
    </>
  );
}
